import { AppSettings } from '@/appSettings'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { Flex, Image, ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react'
import { ContentLabel } from './Insurer'

const baseUrl = AppSettings.baseUrl + '/docs/allianz/'

const AllianzContent = () => {
  return (
    <Stack m={4} gap={10}>
      {/* JAP-2575 - chtějí nyní zobrazit jen dokumenty
      <ZakladniCharakteristika />
      <Varianty />
      */}
      <Documents />
    </Stack>
  )
}

export default AllianzContent

const ZakladniCharakteristika = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Základní charakteristika</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <UnorderedList>
          <ListItem>Územní platnost: Evropa (vč. evropské části Turecka a řecké části Kypru) s výjimkou Běloruska, Moldavska, Ruska a Ukrajiny (u POV státy uvedené na Zelené kartě)</ListItem>
          <ListItem>Frekvence placení: měsíčně a ročně</ListItem>
          <ListItem>Pro všechny fyzické a právnické osoby provozující nebo vlastnící maximálně 5 vozidel</ListItem>
        </UnorderedList>

        <ContentLabel label='Produkt Moje Auto není určen zejména pro zájemce o pojištění:' sx={{ textDecor: 'underline' }} />
        <UnorderedList>
          <ListItem>s vozidly viditelně poškozenými (vyjma balíčku KOMFORT – ten lze nabídnout všem)</ListItem>
          <ListItem>s vozidly staršími 20 let (vyjma balíčku KOMFORT)</ListItem>
          <ListItem>se staršími vozidly, u nichž by pojistné bylo ve zřejmém nepoměru k obvyklé ceně vozidla (týká se balíčků PLUS, EXTRA a MAX)</ListItem>
          <ListItem>s vozidly, která nemají a v dohledné době ani mít nebudou platný český technický průkaz (vyjma balíčku KOMFORT)</ListItem>
          <ListItem>používající svá vozidla výhradně pro závody nebo soutěže</ListItem>
        </UnorderedList>

        <ContentLabel label='Rozsah balíčků podle druhu vozidla' />
        <UnorderedList>
          <ListItem>
            Plný rozsah balíčků je nabízen pro všechna vozidla <strong>vyjma motocyklů/tříkolek/čtyřkolek a přívěsů/návěsů.</strong>
            <UnorderedList listStyleType='circle'>
              <ListItem>Pro motocykly/tříkolky/čtyřkolky nenabízíme pojištění skel.</ListItem>
              <ListItem>Pro přívěs/návěs nenabízíme pojištění skel a úrazové pojištění.</ListItem>
            </UnorderedList>
          </ListItem>
        </UnorderedList>

        <ContentLabel label='Rozsah balíčků podle stáří vozidla' />
        <UnorderedList>
          <ListItem>Balíček KOMFORT – bez omezení stáří vozidla</ListItem>
          <ListItem>Balíčky PLUS, EXTRA a MAX – do 20 let stáří vozidla</ListItem>
          <ListItem>GAP v rámci balíčku MAX – do 6 měs. od 1. registrace/na dobu 2 let</ListItem>
        </UnorderedList>

        <ContentLabel label='Prohlídka při vstupu do pojištění' />
        <UnorderedList>
          <ListItem>Pro balíčky PLUS, EXTRA a MAX</ListItem>
          <ListItem>Povinnost pro vozidla starší 6 měsíců od 1. registrace, pokud pojistné přesáhne 8 000 Kč</ListItem>
        </UnorderedList>

        <ContentLabel label='Spoluúčast' />
        <UnorderedList>
          <ListItem>Volitelná ve výši 5 000 Kč nebo 10 000 Kč – pro pojištění přírodní události, požáru a výbuchu, poškození zvířetem, krádeže, vandalismu, havárie</ListItem>
          <ListItem>Ve výši 1 000 Kč pro pojištění skel v případě jejich výměny (v případě opravy vždy bez spoluúčasti, i do prohlídky)</ListItem>
          <ListItem>Spoluúčast při opravě v nesmluvním servisu v ČR je vždy dvojnásobná</ListItem>
          <ListItem>Při škodě vzniklé do prohlídky vozidla je spoluúčast 50 % z výše škody</ListItem>
        </UnorderedList>

        <ContentLabel label='V pojistném lze zohlednit' />
        <UnorderedList>
          <ListItem>Bonus/Malus</ListItem>
          <ListItem>Nájezd km (pouze pro osobní a nákladní automobily do 3,5 t)</ListItem>
          <ListItem><strong>Sleva za propojištěnnost</strong> (zohledněna pojišťovnou automaticky)</ListItem>
        </UnorderedList>

        <ContentLabel label='Nájezd km' />
        <UnorderedList>
          <ListItem>
            Jak to funguje?
            <UnorderedList listStyleType='circle'>
              <ListItem>Na začátku klient odhadne, kolik kilometrů za rok najede, dle jeho odhadu se odvíjí cena pojištění na daný rok</ListItem>
              <ListItem>Klient dodá fotografii a stav tachometru – po sjednání smlouvy a následně 3 měsíce před výročím smlouvy (před výročím je ze strany pojišťovny vyzván k dodání aktuální fotografie tachometru)</ListItem>
            </UnorderedList>
          </ListItem>
          <ListItem>
            Proč první období je jen 9 měsíců?
            <UnorderedList listStyleType='circle'>
              <ListItem>Aby pojišťovna klientovi dle zákona stihla zaslat nový předpis pojistného nejméně 2 měsíce před výročím, požádá ho o stav tachometru již po 9 měsících od počátku pojištění a ujeté kilometry přepočítá na roční hodnotu.</ListItem>
            </UnorderedList>
          </ListItem>
        </UnorderedList>

        <ContentLabel label='Pojistná událost' />
        <UnorderedList>
          <ListItem>Povinnost opravovat po škodě ve smluvní síti Allianz - platí pro osobní a nákladní automobily do 3,5t u oprav v ČR.</ListItem>
          <ListItem>Při vyřizování škody na základě faktury vystavené jinou opravnou v ČR bude faktura akceptovaná pouze do částky, která nepřevýší běžné náklady na opravu v naší smluvní síti opraven. Dále uplatníme dvojnásobek sjednané spoluúčasti na škodě.</ListItem>
          <ListItem>Při vyřizování škody vzniklé v zahraničí na základě faktury vystavené opravnou mimo ČR bude faktura akceptovaná pouze do částky, která nepřevýší běžné náklady na opravu v naší smluvní síti opraven.</ListItem>
        </UnorderedList>
      </Stack>
    </Stack>
  )
}

const Varianty = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Pojištění lze sjednat ve 4 variantách - balíčkách</Text>
      </Flex>

      <Stack sx={{
        backgroundColor: 'white',
        p: 6
      }}>

        <Text><strong>BALÍČEK KOMFORT</strong> – základní balíček pro ty, kteří nechtějí za pojištění utratit příliš a stačí jim pouze povinné ručení a základní pomoc. Asistenční služby jsou pouze základní, úrazové pojištění se vztahuje pouze na řidiče.</Text>
        <Text><strong>BALÍČEK PLUS</strong> – vhodný pro toho, kdo chce své vozidlo pojistit také pro případ neočekávaných přírodních událostí, které nelze ovlivnit.</Text>
        <Text><strong>BALÍČEK EXTRA</strong> – chrání navíc proti riziku odcizení vozidla, vandalismu nebo poškození skel.</Text>
        <Text><strong>BALÍČEK MAX</strong> – poskytuje ochranu, která navíc obsahuje pojištění vozidla při havárii, kterou sám klient způsobí.</Text>
        <Flex justifyContent='center'><Image src={`${import.meta.env.VITE_BASE_URL}/docs/allianz/picture1.png`} w='auto' /></Flex>

        <ContentLabel label='Povinné ručení' />
        <Text>Povinné ručení chrání pojištěného klienta v případech, kdy vozidlem způsobí jinému újmu na zdraví nebo škodu na majetku. Zabezpečí ho před neočekávanými výdaji spojenými s finančními nároky poškozeného.</Text>
        <Text sx={{ textDecor: 'underline' }}>Limity pojistného plnění dle balíčků:</Text>
        <UnorderedList>
          <ListItem>KOMFORT 70/70 mil. Kč</ListItem>
          <ListItem>PLUS 70/70 mil. Kč</ListItem>
          <ListItem>EXTRA 150/150 mil. Kč</ListItem>
          <ListItem>MAX 150/150 mil. Kč</ListItem>
        </UnorderedList>

        <ContentLabel label='Havárie' />
        <Text>Limit plnění = obvyklá cena vozidla.</Text>
        <Text>Uhradíme škody na pojištěném vozidle vzniklé havárií:</Text>
        <UnorderedList>
          <ListItem>náraz</ListItem>
          <ListItem>střet</ListItem>
          <ListItem>pád</ListItem>
        </UnorderedList>
        <Text>+ vzniklé působením chemických látek na vnější lakované části</Text>
        <Text>Je nutné volat policii – škoda nad 100 000 Kč, zranění, újma třetí straně.</Text>

        <ContentLabel label='Doplatek na nové (GAP)' />
        <Text>Součástí balíčku MAX pro vozidla do 6 měsíců stáří od 1. registrace.</Text>
        <Text>V případě totální škody nebo krádeže vozidla zaplatíme částku, za kterou klient vozidlo koupil, a to bez uplatnění spoluúčasti.</Text>
        <Text>Podmínkou plnění je:</Text>
        <UnorderedList>
          <ListItem>totální škoda nastane <strong>do 2 let</strong> od počátku pojištění</ListItem>
          <ListItem>nárok na pojistné plnění vznikl z pojištění krádeže, havárie, přírodních událostí, požáru nebo výbuchu, vandalismu nebo poškození vozidla zvířetem</ListItem>
        </UnorderedList>

        <ContentLabel label='Skla' />
        <Text>Garantované plnění do výše obvyklé ceny vozidla.</Text>
        <Text><strong>Spoluúčast ve výši 1 000 Kč pro pojištění skel v případě jejich výměny (v případě opravy vždy bez spoluúčasti, i do prohlídky).</strong></Text>
        <Text>Vztahuje se na:</Text>
        <UnorderedList>
          <ListItem>čelní sklo</ListItem>
          <ListItem>boční a zadní skla (kromě autobusů)</ListItem>
          <ListItem>střešní okno nebo skleněné střechy</ListItem>
        </UnorderedList>
        <Text>Pojištění se vztahuje na případy:</Text>
        <UnorderedList>
          <ListItem>přírodní události</ListItem>
          <ListItem>požáru a výbuchu</ListItem>
          <ListItem>poškození zvířetem</ListItem>
          <ListItem>krádeže</ListItem>
          <ListItem>vandalismu</ListItem>
          <ListItem>havárie</ListItem>
        </UnorderedList>

        <ContentLabel label='Základní úrazové pojištění' />
        <Text>Pojištěná osoba – pouze řidič.</Text>
        <Text>Plnění poskytnuto v případě:</Text>
        <UnorderedList>
          <ListItem>smrti řidiče následkem úrazu při dopravní nehodě (limit pojistného plnění: 100 tis. Kč)</ListItem>
          <ListItem>invalidity řidiče následkem úrazu při dopravní nehodě (limit pojistného plnění: 200 tis. Kč)</ListItem>
        </UnorderedList>
        <Text>Invalidita = trvalý pokles pracovní schopnosti o více než 35 %.</Text>

        <ContentLabel label='Rozšířené úrazové pojištění' />
        <Text>Vztahuje se na řidiče a celou posádku vozidla.</Text>
        <Text>Plnění poskytnuto v případě:</Text>
        <UnorderedList>
          <ListItem>smrti pasažéra následkem úrazu při dopravní nehodě (limit pojistného plnění: 200 tis. Kč)</ListItem>
          <ListItem>invalidity pasažéra následkem úrazu při dopravní nehodě (limit pojistného plnění: 400 tis. Kč)</ListItem>
        </UnorderedList>
        <Text>Děti – pojistné plnění vyplatíme při stanovení jakéhokoli stupně závislosti na pomoci jiné osoby.</Text>

        <ContentLabel label='Krádež' />
        <Text>Limit plnění = obvyklá cena vozidla.</Text>
        <UnorderedList>
          <ListItem>Krádež vozidla, jeho části a příslušenství</ListItem>
          <ListItem>Poškození v důsledku krádeže nebo pokusu o krádež</ListItem>
          <ListItem>Loupež a neoprávněné užívání vozidla</ListItem>
        </UnorderedList>
        <Text>Je nutné volat policii.</Text>

        <ContentLabel label='Přírodní události' />
        <Text>Limit plnění = obvyklá cena vozidla.</Text>
        <Text>Škody na pojištěném vozidle vzniklé v důsledku:</Text>
        <UnorderedList>
          <ListItem>povodně a záplavy, vichřice, zemětřesení</ListItem>
          <ListItem>sesuvu půdy nebo lavin, zřícení skal nebo zemin</ListItem>
          <ListItem>krup, úderu blesku</ListItem>
          <ListItem>pádu sněhu, ledu, stromu, větve, stožáru, veřejného sloupu jakéhokoliv vedení nebo osvětlení</ListItem>
        </UnorderedList>

        <ContentLabel label='Poškození zvířetem' />
        <Text>Limit plnění = obvyklá cena vozidla.</Text>
        <Text>Poškození nebo zničení pojištěného vozidla prokazatelně způsobené zvířetem, jako je např.:</Text>
        <UnorderedList>
          <ListItem>srážka s domácím nebo divokým zvířetem</ListItem>
          <ListItem>prokousaná elektroinstalace</ListItem>
        </UnorderedList>
        <Text>Nehradí se škody způsobené přepravovanými nebo ponechanými zvířaty ve vozidle.</Text>

        <ContentLabel label='Vandalismus' />
        <Text>Limit plnění = obvyklá cena vozidla.</Text>
        <Text>Uhradíme škody na pojištěném vozidle vzniklé prokazatelně úmyslným jednáním třetích osob.</Text>
        <Text>Vozidlo musí být v té době zaparkované.</Text>
        <Text>Je nutné volat policii.</Text>

        <ContentLabel label='Požár a výbuch' />
        <Text>Limit plnění = obvyklá cena vozidla.</Text>
        <Text>Uhradíme škody na pojištěném vozidle vzniklé v důsledku:</Text>
        <UnorderedList>
          <ListItem>náhlého a nahodilého požáru</ListItem>
          <ListItem>samovolného výbuchu</ListItem>
        </UnorderedList>

        <ContentLabel label='Asistence' />
        <Text>Viz asistenční list.</Text>

        <ContentLabel label='Rozšířená asistence' />
        <Text>Viz asistenční list.</Text>

        <ContentLabel label='Rozšířený odtah' />
        <Text>Navýšení vzdálenosti pro odtah vozidla z asistence, přičemž výsledná vzdálenost pro odtah je max. 750 km.</Text>

        <ContentLabel label='Právní poradenství' />
        <Text>24 hodin denně/365 dnů v roce poskytujeme telefonické porady týkající se:</Text>
        <UnorderedList>
          <ListItem>šetření dopravní nehody</ListItem>
          <ListItem>jednání s celními úřady</ListItem>
          <ListItem>trestního a přestupkového řízení</ListItem>
          <ListItem>odebrání řidičského nebo technického osvědčení</ListItem>
          <ListItem>koupě a prodeje vozidla (vč. reklamace)</ListItem>
        </UnorderedList>
        <Text>Nevztahuje se mimo jiné na spory mezi klientem a Allianz.</Text>

        <ContentLabel label='+ Přímá likvidace - lze připojistit' />
        <Text>Pokud klienta nabourá jiné auto, nemusí se obracet na pojišťovnu viníka nehody. Vše vyřídíme my a vzniklou škodu klientovi uhradíme bez ohledu na to, kdy se my sami vypořádáme s pojišťovnou viníka.</Text>
        <Text>Uhradíme náklady spojené s:</Text>
        <UnorderedList>
          <ListItem>opravou vozidla</ListItem>
          <ListItem>vyproštěním a odtahem vozidla</ListItem>
          <ListItem>úschovou vozidla</ListItem>
          <ListItem>zapůjčením náhradního vozidlo</ListItem>
        </UnorderedList>
        <Text>Bez spoluúčasti.</Text>
        <Text>Nevztahuje se újmu na zdraví, ušlý zisk atd.</Text>
      </Stack>
    </Stack >
  )
}

const Documents = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={16} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <DocumentsList items={[
          {
            url: baseUrl + 'allianz_2020_produktovy_list.pdf',
            name: 'MojeAuto - produktový list',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'allianz_2020_pruvodce_pojistenim.pdf',
            name: 'MojeAuto - podmínky pojištění',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'allianz_2020_asistencni_list.pdf',
            name: 'MojeAuto - asistenční list',
            documentType: 'pdf'
          }
        ]} />

        <DocumentsList items={[
          {
            url: baseUrl + 'allianz_dokument_pojisteni_vozidel_ipid.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'allianz_samofoceni.pdf',
            name: 'Samofocení - Online prohlídky vozidel pro smlouvy sjednané v Q&B',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'allianz_elektromobil.pdf',
            name: 'Elektromobil - Interní dokument',
            documentType: 'pdf'
          }
        ]} />

        <DocumentsList items={[
          {
            url: 'https://www.cebia.cz/autorizovana-pracoviste/allianz/vinfoto/ceska-republika',
            name: 'Seznam autorizovaných pracovišť pro fotodokumentaci vozidel VINFOTO - podle krajů',
            documentType: 'pdf'
          },
          {
            url: 'https://cebia.com/adresar_pdf/cebia_apc_CZ_275.pdf',
            name: 'Seznam autorizovaných pracovišť pro fotodokumentaci vozidel VINFOTO - celá ČR',
            documentType: 'pdf'
          }
        ]} />
      </Stack>
    </Stack >
  )
}
